<template>
  <div class='detail-wrap'>
    <div class="wrap-border">
      <div class="commitment-btn" @click="downloadHandler" v-if="pdfUrl">信用承诺下载</div>
      <div v-for="(item,index) in detail">
        <div class="company-messages-top ">
          <h2 :title="item.xzxdrmc">{{ item.xzxdrmc }}</h2>
        </div>
        <ul class=" messages-lists">
          <li class="messages-li">
            <span>裁决人类别：</span><span>{{ item.xzxdrlb?item.xzxdrlb:'自然人' }}</span>
          </li>
          <li class="messages-li">
            <span>{{ (item.xzxdrlb === '法人及非法人组织'|| item.xzxdrlb === '个体工商户')? '统一社会信用代码：' : '身份证号码：' }}</span>
            <span>{{ item.xzxdrdm || '————————————'}}</span>
          </li>
          <li class="messages-li">
            <span>裁决种类：</span><span>{{ item.cjzl }}</span>
          </li>
          <li class="messages-li">
            <span>裁决内容：</span><span>{{ item.cjnr }}</span>
          </li>
          <li class="messages-li">
            <span>裁决事由：</span><span>{{ item.cjsy }}</span>
          </li>
          <li class="messages-li">
            <span>法律依据：</span><span>{{ item.flyj }}</span>
          </li>
          <li class="messages-li">
            <span>裁决日期：</span><span>{{ item.cjrq }}</span>
          </li>
          <li class="messages-li">
            <span>裁决机关名称：</span><span>{{ item.cjjgmc }}</span>
          </li>
          <li class="messages-li">
            <span>裁决机关代码：</span><span>{{ item.cjjgdm }}</span>
          </li>
          <li class="messages-li">
            <span>数据来源单位名称：</span><span>{{ item.sjlydwmc }}</span>
          </li>
          <li class="messages-li">
            <span>数据来源单位代码：</span><span>{{ item.sjlydwdm }}</span>
          </li>

        </ul>
      </div>
      <li><span style="color: red;">风险提示：</span><span>本网站仅基于已掌握的信息提供查询服务，查询结果不代表本网站对被查询对象信用状况的评价，仅供参考，请注意识别和防范信用风险。</span></li>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf';
import {promiseDetail, fileDownload} from '@/api';
import BASE_URL from '@/api/base.js'
import promise from "./promise";

export default {
  components: {
    pdf
  },
  data() {
    return {
      pdfUrl: undefined, //注意后端处理跨域
      url: undefined, //jpg路径
      pageNum: 1,
      pageTotalNum: 1, //总页数
      loadedRatio: 0, //当前页面的加载进度，范围是0-1 ，等于1的时候代表当前页已经完全加载完成了,
      detail: []
    }
  },
  created() {
    const promiseDetailObj = JSON.parse(this.$route.query.detailInfo);
    this.detail.push(promiseDetailObj);

  },
  mounted() {
    const {query: {number}} = this.$route;
    console.log(this.$route)
  },
  methods: {
    getPromiseDetail(number) {
      console.log(number)
      let queryData = {
        number

      };
      console.log("------------------------")

      promiseDetail(queryData).then(res => {
        console.log(res)
        console.log(res.records)
        this.detail = res.records
        const {matterfile} = res;
        console.log(matterfile);
        if (matterfile) {
          if (matterfile.endsWith('.pdf')) {
            this.$set(this, 'pdfUrl', BASE_URL + matterfile);
            this.getNumPages()
          }
          if (matterfile.endsWith('.jpg') || matterfile.endsWith('.jpeg')) {
            this.$set(this, 'url', BASE_URL + matterfile);
          }
        }
      })
    },
    downloadHandler() {
      const {file} = this.detail[0];
      window.open(BASE_URL + '/api/file/download?url=' + file, '_blank');
      // fileDownload({
      // 	url: matterfile,
      // }).then(res => {
      // 	let blob = new Blob([res], { type: 'application/pdf' });
      // 	let downloadElement = document.createElement("a");
      // 	let href = window.URL.createObjectURL(blob); //创建下载的链接
      // 	downloadElement.href = href;
      // 	// downloadElement.download = fileName; //下载后文件名
      // 	downloadElement.download = '信用承诺下载'; //下载后文件名
      // 	document.body.appendChild(downloadElement);
      // 	downloadElement.click(); //点击下载
      // 	document.body.removeChild(downloadElement); //下载完成移除元素
      // 	window.URL.revokeObjectURL(href); //释放掉blob对象
      // })
    },
    getNumPages() {
      let loadingTask = pdf.createLoadingTask(this.pdfUrl)
      loadingTask.promise.then(pdf => {
        this.numPages = pdf.numPages
      }).catch(err => {
        console.error('pdf 加载失败', err);
      })
    },

    // 上一页
    prePage() {
      let page = this.pageNum
      page = page > 1 ? page - 1 : this.pageTotalNum
      this.pageNum = page
    },

    // 下一页
    nextPage() {
      let page = this.pageNum
      page = page < this.pageTotalNum ? page + 1 : 1
      this.pageNum = page
    }

  },
  computed: {},
  watch: {},
}
</script>
<style lang='scss' scoped>
.detail-wrap {
  margin: 0 auto;
  padding: 20px 0;
  width: 1280px;

  .wrap-border {
    & + .wrap-border {
      margin-top: 20px;
    }

    position: relative;
    padding: 20px;
    .messages-lists{
      margin: 20px 0px;
      li{
        margin: 10px 0px;
      }
    }
    .el-image{
      margin-bottom: 20px;
    }
    & > .commitment-btn {
      position: absolute;
      top: 20px;
      right: 20px;
      border-radius: 6px;
      width: 150px;
      line-height: 40px;
      background-color: $red;
      color: #fff;
      cursor: pointer;
      text-align: center;
    }

    & > .messages-lists {
      margin-top: 20px;

      & > li {
        flex-basis: 50%;
        text-align: left;
        padding-left: 20px;
        flex-shrink: 0;
        margin: 10px 0;

        &:last-child {
          flex-basis: 100%;
          font-size: 12px;
          color: #aaa;

          span {
            &:first-of-type {
              color: $red;
            }
          }
        }
      }
    }
  }

  .el-button-group {
    .el-button {
      &:not(.is-disabled) {
        background-color: $red;
        border-color: $red;
      }

      &.is-disabled {
        padding: 0 10px;
        color: $red;
        font-size: 14px;
        line-height: 28px;
      }
    }
  }
}
</style>